export enum Characters {
  BOSEF = "/assets/images/bosef.webp",
  BOOGER = "/assets/images/booger.webp",
  BOUNCE = "/assets/images/bounce.webp",
  HELGA = "/assets/images/helga.webp",
  PEGLEG = "/assets/images/pegleg.webp",
  ROCKET = "/assets/images/rocket.webp",
  SHAMAN = "/assets/images/shaman.webp",
  TOILET = "/assets/images/toilet.webp",
}